import UtilityHelper from '../utility-helper/utility-helper';
export default class MdStateSelectElement extends HTMLElement {
  constructor() {
    super();
    this._id = null;
    this._name = null;
    this._defaultValue = null;
    this._required = false;
    this._onChange = this._onChange.bind(this);
  }

  static get observedAttributes() {
    return ['value', 'readonly', 'disabled'];
  }

  connectedCallback() {
    this.fire = UtilityHelper.fireEvent;

    this._setProperties();

    this._attachToDom();

    this._setEvents();

    this._initializeValue();
  }

  disconnectedCallback() {
    this._removeEvents();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (this.select && oldValue) {
      this.select.setAttribute(name, newValue);

      if ((name === 'readonly' || name === 'disabled') && (newValue === 'false' || newValue === false)) {
        this.select.removeAttribute(name);
      }
    }
  }

  _setProperties() {
    var id = this.dataset.id;
    var name = this.dataset.name;
    var value = this.getAttribute('value');
    var required = this.getAttribute('required');
    if (id) this._id = id;else this._id = 'state';
    if (name) this._name = name;else this._name = 'state';
    if (value) this._defaultValue = value;
    if (required) this._required = true;
  }

  _setEvents() {
    var onChange = this._onChange;
    var select = this.querySelector('select');
    this.select = select;
    select.addEventListener('change', onChange);
  }

  _removeEvents() {
    var onChange = this._onChange;
    var select = this.select;
    select.removeEventListener('change', onChange);
  }

  _initializeValue() {
    if (this._defaultValue) {
      this.select.value = this._defaultValue;
      this.select.classList.remove('placeholder-color');
    }
  }

  _onChange(event) {
    this.select.classList.remove('placeholder-color');
    this.fire('md-state-select-change', {
      value: event.target.value,
      target: this
    });
  }

  _attachToDom() {
    var dom = '<div class="input-group">';
    var requiredAttribute = '';

    if (this._required) {
      requiredAttribute = ' required';
    }

    dom += '<select class="placeholder-color" id="' + this._id + '" name="' + this._name + '"' + requiredAttribute + '>';
    dom += this._getOptions();
    dom += '</select>';
    dom += '<i class="material-icons select-icon">keyboard_arrow_down</i>';
    dom += '<span class="bar"></span>';
    dom += '</div>';
    var $dom = $(dom);
    $(this).append($dom);
    this.select = this.querySelector('select');
  }

  _getOptions() {
    var options = '<option value="Select">Select State</option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option><option value="AS">American Samoa</option><option value="GU">Guam</option><option value="MP">Northern Mariana Islands</option><option value="PR">Puerto Rico</option><option value="UM">United States Minor Outlying Islands</option><option value="VI">Virgin Islands</option>';
    return options;
  }

  get value() {
    return this.select.value;
  }

  set value(val) {
    this.select.value = val;
    this.setAttribute('value', val);
  }

  clear() {
    this.select.value = '';
  }

}
customElements.define('md-state-select', MdStateSelectElement);